import { create } from 'zustand';

const state = { isDragFile: false };

export const useDragFile = create((set) => ({
    ...state,
    onChangeDragFile: (newState) => set((state) => ({ ...state, ...newState })),
    onResetDragFile: () => set(() => ({ ...state })),
}));
